<template>
  <div class="page">
    <van-nav-bar title="品牌效果" left-arrow @click-left="$router.back()"/>
    <div class="grid">
      <div v-for="card in cards" :key="card.key"><span>{{ card.label }}</span><b>{{ value(card.key) }}</b></div>
    </div>
    <section><h2>目标与实际</h2>
      <van-cell v-for="item in requirements" :key="field(item,'id')" :title="field(item,'title')"
                :label="'预期：'+(field(item,'expected_result')||'未填写')"/>
    </section>
  </div>
</template>
<script>import api from "@/api/brand";

export default {
  data() {
    return {
      report: {},
      requirements: [],
      cards: [{key: "content_count", label: "内容数"}, {key: "published_count", label: "发布数"}, {
        key: "average_score",
        label: "平均分"
      }, {key: "view_count", label: "阅读/播放"}, {key: "like_count", label: "点赞"}, {key: "comment_count", label: "评论"}, {
        key: "share_count",
        label: "分享/转发"
      }, {key: "conversion_count", label: "转化"}]
    }
  }, created() {
    Promise.all([api.report(), api.requirements()]).then(([r, q]) => {
      this.report = r;
      this.requirements = q
    }).catch(e => this.$toast.fail(e.message))
  }, methods: {
    field(r, k) {
      return r[k] !== undefined ? r[k] : r[k.toUpperCase()]
    }, value(k) {
      const v = this.field(this.report, k);
      return k === 'average_score' ? Number(v || 0).toFixed(1) : (v || 0)
    }
  }
};</script>
<style lang="less" scoped>
@import "./brand-page.less";

.grid {
  display: grid;
  grid-template-columns:repeat(2, minmax(0, 1fr));
  padding: .12rem;
  background: #fff
}

.grid div {
  position: relative;
  min-height: 1.25rem;
  padding: .26rem .24rem;
  border-bottom: 1px solid #eceef3
}

.grid div:nth-child(odd) {
  border-right: 1px solid #eceef3
}

.grid div:nth-last-child(-n+2) {
  border-bottom: 0
}

.grid div::before {
  position: absolute;
  top: .31rem;
  left: .04rem;
  width: .05rem;
  height: .3rem;
  border-radius: .04rem;
  background: #d32f2f;
  content: ""
}

.grid div:nth-child(3n+2)::before {
  background: #ee8b2d
}

.grid div:nth-child(3n)::before {
  background: #31ae76
}

.grid span {
  display: block;
  color: #777b8e;
  font-size: .25rem
}

.grid b {
  display: block;
  margin-top: .1rem;
  color: #34364a;
  font-size: .43rem;
  line-height: 1.2
}

section {
  padding-bottom: .08rem
}

section /deep/ .van-cell__title {
  font-weight: 600
}

section /deep/ .van-cell__label {
  color: #9295a7
}
</style>



// WEBPACK FOOTER //
// src/views/brand/BrandReport.vue